import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AdminState {
    actionableTrades: number;
    actionableTransaction: number;
}

const initialState: AdminState = {
    actionableTrades: 0,
    actionableTransaction: 0,
};

export const adminSlice = createSlice({
    name: 'admin',
    initialState,
    reducers: {
        setAdminState: (state, action: PayloadAction<Partial<AdminState>>) => {
            return { ...state, ...action.payload };
        },
    },
});

export const { setAdminState } = adminSlice.actions;

export default adminSlice.reducer;